import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/leftSlide/hintCenter.png';
const _withScopeId = n => (_pushScopeId("data-v-4a5dadc6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "confirmWrapper"
};
const _hoisted_2 = {
  class: "confirmWrapper_content ab-center"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "circle"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "ab-center",
  src: _imports_0,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("span", null, "删除提示")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mid"
}, " 删除当前AI助手，该助手的训练资料和对话信息将全部一起删除不可找回。是否需要删除？ ", -1));
const _hoisted_5 = {
  class: "bom"
};
import { useStore } from 'vuex';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: ['title', 'content'],
  emits: ['btnClick'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const store = useStore();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => emits('btnClick', true)),
        class: "cursor-p deleteBtn hintCommBtn"
      }, " 删除 "), _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => emits('btnClick', false)),
        class: "cursor-p cancelBtn hintCommBtn"
      }, " 取消 ")])])]);
    };
  }
});